import { useUserRoles } from '@anytag/auth';
import {
  CreateSocialAccountAnalyticsAdvertiserInputV2,
  useCreateSocialAccountAnalyticsAdminV2Mutation,
  useCreateSocialAccountAnalyticsAdvertiserV2Mutation
} from '@anytag/graphql';
import { UNEXPECTED_ERROR } from '@anytag/shared-constants';
import { useQueryHelper, useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { AnalyticsForm, AnalyticsFormValues } from '@anytag/shared-organisms';
import { FormAction } from '@anytag/shared-types';

export const AddAnalyticsAccount = () => {
  useUpdateDocumentTitle({
    title: 'documentTitle.AddAccount',
    appHeader: 'appHeader.Add Account',
    href: '/analytics',
    alwaysBackToParent: true
  });
  const { isAdvertiser } = useUserRoles();
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { callCreateSocialAccountAnalyticsAdminV2 } = useCreateSocialAccountAnalyticsAdminV2Mutation();
  const { callCreateSocialAccountAnalyticsAdvertiserV2 } = useCreateSocialAccountAnalyticsAdvertiserV2Mutation();

  const handleSubmit: FormAction<AnalyticsFormValues>['onSubmit'] = async (values) => {
    try {
      const input: CreateSocialAccountAnalyticsAdvertiserInputV2 = {
        accountName: values.accountName,
        youtubeChannelId: values.youtube?.channelId,
        twitterUserId: values.twitter?.twitterUserId,
        facebookPageId: values.facebookPage?.fbPageId,
        instagramUserId: values.instagram?.id ? String(values.instagram?.id) : undefined
      };

      if (isAdvertiser) {
        await callCreateSocialAccountAnalyticsAdvertiserV2({ variables: { input } });
      } else {
        await callCreateSocialAccountAnalyticsAdminV2({
          variables: {
            input: {
              ...input,
              advertiserId: Number(values.advertiserId),
              accountManagersPICs: values.accountManagerIds?.map(Number)
            }
          }
        });
      }

      enqueueSnackbar(t('succeededInCreating', { name: values.accountName }), { variant: 'success' });
      navigate({ to: '/analytics' });
    } catch (error) {
      enqueueSnackbar(t('failedToCreateAnalyticsAccount'), { variant: 'error' });
      enqueueSnackbar(t(error.message || UNEXPECTED_ERROR), { variant: 'error' });
    }
  };

  return (
    <div>
      <Header />
      <AnalyticsForm onSubmit={handleSubmit} />
    </div>
  );
};
